import { Component } from "react"
import PropTypes from "prop-types"

import SortableWrapper from "shared/components/sortable_wrapper"
import editIcon from "images/partners/edit.svg"
import QueryFieldForm from "./query_fields_form"
import { getQueryFields, queryFieldUpdate } from "./gql"

import "./query_fields.scss"

class QueryFields extends Component {
  constructor(props) {
    super(props)
    this.state = {
      queryFields: [],
      showNewForm: false,
    }
  }

  componentDidMount() {
    getQueryFields(this.props.query).then(queryFields => {
      this.setState({
        queryFields: queryFields.sort((a, b) => a.weight - b.weight),
      })
    })
  }

  updateQueryFields = (action, queryField) => {
    let queryFields = this.state.queryFields
    switch (action) {
      case "add":
        queryFields = [...queryFields, queryField]
        break
      case "update":
        const index = queryFields.findIndex(qf => qf.id === queryField.id)
        queryFields = [
          ...queryFields.slice(0, index),
          queryField,
          ...queryFields.slice(index + 1),
        ]
        break
      case "delete":
        queryFields = queryFields.filter(qf => qf.id !== queryField.id)
        break
    }
    this.setState({ queryFields })
  }

  toggleNewForm = () => {
    this.setState({ showNewForm: !this.state.showNewForm })
  }

  handleOrderChange = newFields => {
    const oldFields = this.state.queryFields
    newFields.forEach((f, index) => (f.weight = index))
    this.setState({ queryFields: newFields })
    Promise.all(newFields.map(queryFieldUpdate))
      .then(queryFieldsResp => {
        window.appendFlash("Query fields reordered")
      })
      .catch(errs => {
        this.setState({ queryFields: oldFields })
        window.appendFlash(
          "Could not reorder query fields — please try again",
          "danger"
        )
      })
  }

  render() {
    return (
      <>
        <section className="action-sections action-inputs form-section">
          <a id="banned_label"></a>
          <a id="banned_helper"></a>
          <a id="banned_dropdown"></a>
          <a id="query-fields"></a>
          <h3>Query fields</h3>

          <p>
            To make queries as relevant to the user as possible you can let
            users provide one or more query fields. For example, the "Tweet by
            you with hashtag" query would require a query field to specify the
            hashtag to look for. Read the full documentation on{" "}
            <a href={`${this.props.referenceUrl}#query-fields`}>query fields</a>
            .
          </p>

          <SortableWrapper
            signature={this.state.queryFields.map(i => i.id).join(":")}
            items={this.state.queryFields}
            onOrderUpdate={this.handleOrderChange}
          >
            <ul className="field-list draggable-list">
              {this.state.queryFields.map(qf => (
                <QueryFieldItem
                  key={qf.id}
                  {...this.props}
                  queryField={qf}
                  updateQueryFields={this.updateQueryFields}
                />
              ))}
            </ul>
          </SortableWrapper>

          {this.state.showNewForm ? (
            <div styleName="field-edit">
              <QueryFieldForm
                {...this.props}
                queryField={{}}
                updateQueryFields={this.updateQueryFields}
                hideForm={this.toggleNewForm}
                create
              />
            </div>
          ) : (
            <div className="action">
              <button
                onClick={this.toggleNewForm}
                disabled={this.props.service.is_published}
                className="button-tertiary add-field"
              >
                Add query field +
              </button>
            </div>
          )}
        </section>
      </>
    )
  }
}

QueryFields.propTypes = {
  service: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  referenceUrl: PropTypes.string.isRequired,
  protocolUrl: PropTypes.string.isRequired,
}

class QueryFieldItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showForm: false,
    }
  }

  toggleForm = () => {
    this.setState({ showForm: !this.state.showForm })
  }

  render() {
    if (this.state.showForm) {
      return (
        <div styleName="field-edit">
          <QueryFieldForm {...this.props} hideForm={this.toggleForm} />
        </div>
      )
    } else {
      return (
        <li>
          {this.props.queryField.label}
          <span className="links">
            <a title="Edit query field" onClick={this.toggleForm}>
              <span
                className="svg-edit-icon"
                dangerouslySetInnerHTML={{ __html: editIcon }}
              />
            </a>
          </span>
        </li>
      )
    }
  }
}

QueryFieldItem.propTypes = {
  service: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  protocolUrl: PropTypes.string.isRequired,
  updateQueryFields: PropTypes.func.isRequired,
  queryField: PropTypes.object,
}

export default QueryFields
